import { toast } from 'react-toastify';

const defaultConfig = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: "light",
};

export const showToast = {
  success: (message, config = {}) => {
    toast.success(message, {
      ...defaultConfig,
      ...config,
      autoClose: config.autoClose || 3000,
    });
  },

  error: (message, config = {}) => {
    toast.error(message, {
      ...defaultConfig,
      ...config,
    });
  },

  warning: (message, config = {}) => {
    toast.warning(message, {
      ...defaultConfig,
      ...config,
    });
  },

  info: (message, config = {}) => {
    toast.info(message, {
      ...defaultConfig,
      ...config,
    });
  },
};

// Helper function to extract error message from API response
export const getErrorMessage = (error) => {
  if (error.response?.data?.message) {
    return error.response.data.message;
  }
  if (error.response?.data?.error) {
    return error.response.data.error;
  }
  if (error.message) {
    return error.message;
  }
  return 'Something went wrong. Please try again.';
}; 